module.exports = __webpack_public_path__ + "media/images/help_template_interview-3d5ebba0d1cfc21b13069780f83edfba.png";